var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowsUpDownUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22.31 24.6261 4.3362-4.6302c.1966-.2586.3538-.5903.3538-.8672 0-.6823-.4942-1.1805-1.1401-1.1805-.2977 0-.5786.1476-.792.3689l-1.8086 1.9556-.6684.7745.0393-9.2952c0-.6641-.4943-1.1623-1.1402-1.1623-.6684 0-1.1459.4982-1.1459 1.1623l.0394 9.2952-.6685-.7745-1.8254-1.9739c-.2135-.2214-.4943-.3506-.7919-.3506-.646 0-1.1066.4799-1.1066 1.1805 0 .2952.1404.6458.337.8672l4.3194 4.6302c.4212.461 1.157.5348 1.6625 0z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.66761 7.36024-4.3025 4.64846c-.20783.2214-.36511.572-.36511.8483 0 .7012.47181 1.1994 1.12336 1.1994.31455 0 .61227-.1292.80886-.3506l1.80298-1.9739.66844-.7379-.03374 9.6381c0 .6824.48868 1.1806 1.1402 1.1806.6516 0 1.1403-.4982 1.1403-1.1806l-.0338-9.6564.6685.7562 1.8086 1.9739c.2246.2214.4887.3506.8032.3506.6684 0 1.1065-.4799 1.1065-1.1994 0-.2763-.1236-.6086-.3146-.8483l-4.3193-4.64846c-.4212-.44272-1.2301-.5165-1.70189 0z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsUpDownUp);
export default __webpack_public_path__ + "static/media/Arrows_Up-Down-UP.11f0068ee4f0c28c299f907102edd540.svg";
export { ForwardRef as ReactComponent };